export const REPORTS_ROOT_ROUTE = `/reports`

export const getReportsRoute = () => REPORTS_ROOT_ROUTE
